import React from 'react';
import { DataColumn, List } from 'components/lists';
import { renderTime, weekDays } from 'utils/dayTimeHelpers';

export const RKeeperDiscountUsages = ({ usages, dayTimes, times, restaurants }) => {
  return (
    <div className="-mt-8">
      <List
        source={usages || []}
        keyField="usage_id"
      >
        <DataColumn
          name="Type"
          dbColumnName="type"
          headerClass="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 table-cell"
          dataCellClass="whitespace-nowrap px-3 py-4 text-sm text-gray-500 table-cell"
        />
        <DataColumn
          name="Priority"
          dbColumnName="priority"
          headerClass="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 table-cell"
          dataCellClass="whitespace-nowrap px-3 py-4 text-sm text-gray-500 table-cell"
        />
        <DataColumn
          name="Restaurants"
          dbColumnName="restaurants"
          render={(item) => {
            const names = [];

            if (item.restaurants) {
              item.restaurants.forEach((restaurantId) => {
                const restaurantData = restaurants ? restaurants.find((x) => x._id === restaurantId) : null;

                if (restaurantData) {
                  names.push(restaurantData.name);
                }
              });
            }

            return names.join(', ');
          }}
          headerClass="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 table-cell"
          dataCellClass="whitespace-nowrap px-3 py-4 text-sm text-gray-500 table-cell"
        />
        <DataColumn
          name="Period"
          render={(item) => {
            const formedPeriods = [];

            const usageDayTimes = dayTimes?.filter((x) => x.usage_id === item.usage_id);
            const usageTimes = times?.filter((x) => x.usage_id === item.usage_id);

            if (usageDayTimes && usageDayTimes.length > 0) {
              usageDayTimes.forEach((dayTime) => {
                const dayName = weekDays.find((x) => x.value === dayTime.day);

                formedPeriods.push(`${dayName?.label || dayTime.day} ${renderTime(dayTime.from_hour, dayTime.from_minute)} - ${renderTime(dayTime.to_hour, dayTime.to_minute)}`);
              });
            }

            if (usageTimes && usageTimes.length > 0) {
              usageTimes.forEach((time) => {
                formedPeriods.push(`${renderTime(time.from_hour, time.from_minute)} - ${renderTime(time.to_hour, time.to_minute)}`);
              });
            }

            return formedPeriods.map((formedString) => <div>{formedString}</div>);
          }}
          headerClass="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 table-cell"
          dataCellClass="px-3 py-4 text-sm text-gray-500 table-cell"
        />
      </List>
    </div>
  );
};
